import React, { Component } from "react";
import Header from "../layout/Header";
import Banner from "../Common/Banner";

export default class AboutChairman extends Component {
  render() {
    return (
      <div className="body_wrapper">
        <Header />
        <Banner title="Chairman's Message" image="banners/About.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl paddingtop-2">
            <div className="row">
              <div className="col-lg-3">
                <div className="ttm-featured-wrapper">
                  <div className="featured-thumbnail text-center">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/assets/images/aboutchairman/chairman.jpeg`
                      }
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-9 justify" style={{ margin: "auto" }}>
                <div className="ttm-team-member-content shadow-box res-991-mt-30">
                  <div className="ttm-team-member-content shadow-box res-991-mt-30">
                    <div className="ttm-team-member-single-list">
                      <h2 className="ttm-team-member-single-title">
                        Sri. Hanumatharayappa R
                      </h2>
                      <span className="ttm-team-member-single-position">
                        Chairman, KIPT, RVS
                      </span>
                      <hr />
                      <p>
                        Kempegowda Institute of Physiotherapy College is one of
                        the superior and pioneer institutes in the state of
                        Karnataka imparting quality of education in the field of
                        Physiotherapy at Under Graduate, Post Graduate and Ph.D
                        level. Our vision is based on hard work, open
                        communication, a strong emphasis on team work and high
                        level of responsibility. This visionary culture allows
                        and emphasizes our students not only to adopt the
                        present day challenges but also individual
                        responsibilities to the society and our nation at large.
                      </p>
                      <p>
                        The dedicated, hard working and committed Teaching and
                        Non-teaching faculty of our institute have ensured that
                        the students become competent, confident, self-reliant,
                        lifelong learners ready for the change and stand proudly
                        in the various aspects and fields of Physiotherapy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 paddingtop-2 justify">
                <p>
                  I am confident that the students who aspire to join in our
                  college will be provided with holistic education and a chance
                  to serve the society at large.
                </p>
                <p>With Best Regards</p>
                <p>
                  <b style={{ fontWeight: "bold" }}>Sri. Hanumatharayappa R</b>
                  <br />
                  Chairman, KIPT, RVS
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
